import * as yup from "yup";

export interface RsvpSettingsData {
    allowTableSelection: boolean;
    canRsvp: boolean;
    canRsvpGuests: boolean;
    deadline: Date | null;
    // seatingChartUrl: string | null;
    seatsAvailable: number | null;
    seatsPerTable: number | null;
}

export const RsvpSettingsSchema = yup.object<RsvpSettingsData>().shape({
    allowTableSelection: yup.bool().label("Allow table selection"),
    canRsvp: yup.bool().label("Registrants can RSVP to this event"),
    canRsvpGuests: yup.bool().label("Registrants can RSVP guests"),
    deadline: yup.date().label("RSVP deadline").nullable(true).when(["canRsvp"], (canRsvp: boolean) => {
        const schema = yup.date().label("RSVP deadline").nullable(true);
        return canRsvp
            ? schema.required()
            : schema;
    }),
    // seatingChartUrl: yup.string().label("Seating chart").nullable(true),
    seatsAvailable: yup.number().label("Seats available").nullable(true).min(1).when(["canRsvp"], (canRsvp: boolean) => {
        const schema = yup.number().label("Seats available").nullable(true).min(1);
        return canRsvp
            ? schema.required()
            : schema;
    }),
    seatsPerTable: yup.number().label("Seats per table").nullable(true).min(1).when(["canRsvp", "allowTableSelection"],
        (canRsvp: boolean, allowTableSelection: boolean) => {
            const schema = yup.number().label("Seats per table").nullable(true).min(1);
            return canRsvp && allowTableSelection
                ? schema.required()
                : schema;
        }),
});

export const DefaultRsvpSettings: RsvpSettingsData = {
    allowTableSelection: false,
    canRsvp: false,
    canRsvpGuests: false,
    deadline: null,
    // seatingChartUrl: null,
    seatsAvailable: null,
    seatsPerTable: null,
};



// WEBPACK FOOTER //
// ./src/forms/adminEvent/RsvpSettings.ts